import { render, staticRenderFns } from "./BotaoRelatorios.vue?vue&type=template&id=c44ebd96&lang=pug"
import script from "./BotaoRelatorios.vue?vue&type=script&lang=js"
export * from "./BotaoRelatorios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports